import { Autocomplete, TextField, createFilterOptions } from "@mui/material";

const filter = createFilterOptions();

export default function CategorySelect({
  id,
  value,
  onChange,
  options,
}) {

  return (
    <Autocomplete
      freeSolo
      value={value || ""}
      onChange={(event, newValue) => {
        
        //fall back 
        if (!event?.type || event.type === "blur") return;


        if (typeof newValue === "string") {
          // user typed and pressed Enter
            
          onChange(newValue);
        } else if (newValue && newValue.inputValue) {

          // user selected the "(new category)" option
          onChange(newValue.inputValue);
        } else {

          // user selected existing option
          onChange(newValue?.label || "");
        }
      }}
      //to filter options to check if the name exists
      filterOptions={(opts, params) => {
        const filtered = filter(opts, params);

        const { inputValue } = params;

        //to check if typed value already exists
        const isExisting = opts.some(
          (option) => inputValue.toLowerCase() === option.label.toLowerCase()
        );

        //to create a new category name
        if (inputValue !== "" && !isExisting) {
          filtered.push({
            label: `${inputValue} (New category)`,
            inputValue,
          });
        }

        return filtered;
      }}
      selectOnFocus      
      handleHomeEndKeys
      autoHighlight
      autoSelect={false}
      disableClearable
      options={options}
      getOptionLabel={(option) => {

        // Value selected with enter, right from input
        if (typeof option === "string") {
          return option;
        }

        // Add new option created dynamically
        if (option.inputValue) {
          return option.label;
        }

        // Regular option
        return option.label;
      }}
      renderInput={(params) => (
        <TextField {...params} variant="outlined" />
      )}
    />
  );
}
